import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Initialize the application
initializeApp().catch((error) => {
  console.error('Application initialization failed:', error);
});

async function initializeApp(): Promise<void> {
  try {
    const env = await fetchEnvironmentConfig();
    Object.assign(environment, env);

    await loadMicroFeResources(env);

    await bootstrapAngularApp();
  } catch (error) {
    console.error('Error during app initialization:', error);
  }
}

async function fetchEnvironmentConfig(): Promise<any> {
  try {
    const response = await fetch('assets/config/environment.json');
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const env = await response.json();
    return env;
  } catch (error: any) {
    throw new Error(`Failed to fetch environment configuration: ${error.message}`);
  }
}



async function loadMicroFeResources(env: any): Promise<void> {
  try {
    await Promise.all([
      loadScript(`${env.mfeBaseUrl}micro-fe.js`),
      loadStylesheet(`${env.mfeBaseUrl}styles.css`),
    ]);
  } catch (error: any) {
    console.warn('Non-critical MFE resource failed to load:', error.message);
  }
}

function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
}

function loadStylesheet(href: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`Failed to load stylesheet: ${href}`));
    document.head.appendChild(link);
  });
}

async function bootstrapAngularApp(): Promise<void> {
  try {
    const { AppModule } = await import('./app/app.module');
    await platformBrowserDynamic().bootstrapModule(AppModule);
    console.log('Angular app bootstrapped successfully.');

    if ('serviceWorker' in navigator && environment.production) {
      navigator.serviceWorker.register('./ngsw-worker.js');
    }
  } catch (error) {
    console.error('Angular app bootstrap failed:', error);
    throw error;
  }
}
